import React from "react"

interface BadgeProps {
  children?: React.ReactNode
  text?: string
  variant?: 'default' | 'success' | 'warning' | 'error' | 'info' | 'outline'
  className?: string
}

export function Badge({ children, text, variant = 'default', className = '' }: BadgeProps) {
  const variants = {
    default: 'bg-secondary text-foreground',
    success: 'bg-emerald-500/20 text-emerald-400',
    warning: 'bg-amber-500/20 text-amber-400',
    error: 'bg-red-500/20 text-red-400',
    info: 'bg-blue-500/20 text-blue-400',
    outline: 'border border-border bg-transparent text-foreground',
  }

  return (
    <span
      className={`inline-block px-3 py-1 rounded-full text-xs font-semibold ${variants[variant]} ${className}`}
    >
      {text || children}
    </span>
  )
}
